export default {
    name: 'RequestUtil',
    axiosInstance: null,
    install(axiosInstance) {
        // console.log('RequestUtil install')
        this.axiosInstance = axiosInstance
        window.$$get = async function (url, params) {
            return (await axiosInstance.get(url, {params})).data
        }
        window.$$post = async function (url, data) {
            return (await axiosInstance.post(url, data || {})).data
        }
    },
    async $$get(url, params) {
        return (await this.axiosInstance.get(url, {params})).data
    },
    async $$post(url, data) {
        return (await this.axiosInstance.post(url, data || {})).data
    },
    async $page(entityName, params) {
        return await $$get(`/common/selectPages/${entityName}`, params)
    },
    async $list(entityName, params) {
        return await $$get(`/common/selectLists/${entityName}`, params)
    },
    async $one(entityName, id) {
        return await $$get(`/common/selectOne/${entityName}`, {id})
    },
    async $insert(entityName, data) {
        await $$post(`/common/insert/${entityName}`, data)
    },
    async $saveOrUpdate(entityName, data) {
        await $$post(`/common/insertOrUpdate/${entityName}`, data)
    },
    async $updateById(entityName, data) {
        await $$post(`/common/update/${entityName}`, data)
    },
    async $deleteById(entityName, id) {
        await $$post(`/common/delete/${entityName}/${id}`)
    },
    appendParams(url, params) {
        if (!url.includes('?')) {
            url += '?'
        }
        return url + Object.keys(params)
            .map(key => params[key] && `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&')
    },
}
// export default new ObjectUtil()
